import React, {Component} from 'react';
import {BrowserRouter as Router, Route, Link, Redirect, Switch, withRouter} from "react-router-dom";
import './css/App.css';
import './css/Mystyle.css';
import Home from './components/home';
import Aboutus from './components/aboutus';
import Howitworks from './components/howitworks';
import Privacy from './components/privacy';
import Terms from './components/terms';
import Disclaimer from './components/disclaimer';
import Product from './components/product';
import AnnualReturn from './components/annualReturn';
import Faq from './components/faq';
import Ourpartner from './components/partner';
import Emailerlogin from './components/emailerlogin';
import Howdoesthis from './components/how_does_this_app_works';
import Media from './components/media/Index';
import EmergencyLoan from './components/EmergencyLoan';
import RevLoan from './components/RevLoan';
import RevLoanLimit from './components/RevLoanLimit';
import ProductDetail from './components/ProductDetail';
import RevAthon from './components/RevAthon';
import RevAthonMobile from './components/RevAthonMobile';
import ISpolicystatement from './components/ISpolicystatement';
import Aristo from './components/aristo'
import {cancelEMandate} from "./components/cancelEMandate";
import Career from "./components/Career";
import JobDescription from './components/JobDescription';
import GetStarted from './components/GetStarted';
import Contact from './components/Contact';
import NewsBlogsPage from './components/NewsBlogsPage';
import DeeplinkRedirect from "./components/DeeplinkRedirect";
import WebsiteBot from './components/website-bot/WebsiteBot';
import "aos/dist/aos.css";
import AOS from 'aos';
import LinkGenerator from "./components/LinkGenerator";
import { UnderMaintenance } from './underMaintenance';
import axios from 'axios'
import config from 'config'


class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isUnderMaintenance:false
        }
      }

    isUnderMaintenance = async() => {
       await axios.get(`${config.REV_URL}/is-under-maintenance`)

        .then((res) => {
            this.setState({isUnderMaintenance: res.data.data.isUnderMaintenance})
          })
        .catch((e) => {
          console.error(`API call error:${e}`);
        });
    };

    componentDidMount() {
        this.isUnderMaintenance()
        // or simply just AOS.init();
        AOS.init({
            // Global settings:
            disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
            startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
            initClassName: 'aos-init', // class applied after initialization
            animatedClassName: 'aos-animate', // class applied on animation
            useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
            disableMutationObserver: false, // disables automatic mutations' detections (advanced)
            debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
            throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

            // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
            offset: 120, // offset (in px) from the original trigger point
            delay: 0, // values from 0 to 3000, with step 50ms
            duration: 1000, // values from 0 to 3000, with step 50ms
            easing: 'ease', // default easing for AOS animations
            once: false, // whether animation should happen only once - while scrolling down
            mirror: false, // whether elements should animate out while scrolling past them
            anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation

        });
    }

    render() {
        return (
            <div>
                <Router>
                    <div className="full-w" id="body">
                    {this.state.isUnderMaintenance &&<Route path={window.location.pathname}>
                                <Redirect to="/under-maintenance" />
                            </Route> }
                        <Switch>
                            <Route exact path="/" component={Home}/>
                            <Route path="/about-us" component={Aboutus}/>
                            <Route path="/privacy_and_policy" component={Privacy}/>
                            <Route path="/ispolicystatement" component={ISpolicystatement}/>
                            <Route path="/terms_and_conditions" component={Terms}/>
                            <Route path="/faq" component={Faq}/>
                            <Route path="/disclaimer-revised" component={Disclaimer}/>
                            <Route path="/product" component={Product}/>
                            <Route exact path="/media" component={Media}/>
                            <Route path="/personal-loan" component={Product}/>
                            <Route path="/partner" component={Ourpartner}/>
                            <Route path="/electric-vehicle-loan" component={Product}/>
                            <Route path="/howitworks" component={Howitworks}/>
                            <Route path="/campaignform" component={Emailerlogin}/>
                            <Route path="/how_does_this_app_works" component={Howdoesthis}/>
                            <Route path="/eloan/:id" component={EmergencyLoan}/>
                            <Route path="/rl/:id" component={RevLoan}/>
                            <Route path="/rll/:id" component={RevLoanLimit}/>
                            <Route path="/ProductDetail/:id" component={ProductDetail}/>
                            <Route path="/revAthon" component={RevAthon}/>
                            <Route path="/RevAthonMobile" component={RevAthonMobile}/>
                            <Route path="/moratorium" component={Aristo}/>
                            <Route path="/cancelmandate" component={cancelEMandate}/>
                            <Route path="/career" component={Career}/>
                            <Route path="/job/:id" component={JobDescription}/>
                            <Route exact path="/product/#:id" component={Product}/>
                            <Route path="/get-started" component={GetStarted}/>
                            <Route path="/contact" component={Contact}/>
                            <Route path="/news&blogs" component={NewsBlogsPage}/>
                            <Route path="/app-download" component={DeeplinkRedirect} />
                            <Route path='/links/:id' component={LinkGenerator} />
                            <Route path='/under-maintenance' component={UnderMaintenance} />
                            <Route path='/annual-returns' component={AnnualReturn} />
                        </Switch>
                    </div>
                </Router>

            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js